import React from 'react';

import { Chip } from '@mui/material';

interface Props {
  campaignType: string;
}

export default function CampaignTypeChip({ campaignType }: Props) {
  return <Chip color="primary" label={campaignType} size="small" />;
}
